import { useEffect } from "react";

// @ts-expect-error There are no types for stats.js
import * as Stats from "stats-js";

export default function useStats(enable: boolean) {
  useEffect(() => {
    if (!enable) return;

    // Initialize stats.js
    const stats = new Stats();
    stats.showPanel(0); // 0: FPS, 1: ms, 2: memory
    document.body.appendChild(stats.dom);

    // Animation loop to update stats
    const updateStats = () => {
      stats.begin();
      stats.end();
      requestAnimationFrame(updateStats); // Continues the loop
    };

    const animationFrameId = requestAnimationFrame(updateStats); // Start the loop

    // Cleanup
    return () => {
      document.body.removeChild(stats.dom);
      cancelAnimationFrame(animationFrameId);
    };
  }, [enable]);
}
